import { createFileRoute } from "@tanstack/react-router";
import { loadStandalonePage } from "~/utils/content-fns";
import { BlockRenderer } from "~/components/blocks";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/integrations/mcp-servers")({
  loader: async () => {
    const page = await loadStandalonePage({
      data: { path: "integrations/mcp-servers.md" },
    });
    return {
      title: (page.title as string) || "",
      seo_title: page.seo_title as string | undefined,
      seo_description: page.seo_description as string | undefined,
      blocks: (page.blocks as any[]) || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: seo({
      title: (loaderData as any)?.seo_title || (loaderData as any)?.title,
      description: (loaderData as any)?.seo_description || "",
      url: "/integrations/mcp-servers",
    }),
    links: seoLinks({ url: "/integrations/mcp-servers" }),
  }),
  component: () => {
    const p = Route.useLoaderData() as any;
    return <BlockRenderer blocks={p.blocks || []} />;
  },
});
